import { useLingui } from '@lingui/react';
import { useCompanyIdMaybe } from '@startuptools/common/react-wrapper';
import { useNavigate as _useNavigate, NavigateOptions, useLocation } from 'react-router-dom';
import { isPromise } from '../helpers/is-promise';

export const useNavigate = () => {
  const { i18n } = useLingui();
  const companyId = useCompanyIdMaybe();
  const _navigate = _useNavigate();
  const { pathname } = useLocation();

  const rootPath = `/${i18n.locale}`;
  const companyRootPath = `${rootPath}/company`;
  const companyPath = `${companyRootPath}/${companyId}`;
  const authPath = `${rootPath}/auth`;

  const link = (to: string, overrideRoot?: string) => {
    return `${overrideRoot ?? companyPath}${to}`;
  };

  const navigate = (to: string, overrideRoot?: string, options?: NavigateOptions) => {
    const res = _navigate(link(to, overrideRoot), options);
    if (!isPromise(res)) {
      return Promise.resolve(res);
    }
    return res;
  };

  const changeCompanyLink = (id: string) => {
    return link(`/${id}`, companyRootPath);
  };

  const changeCompany = (id: string) => {
    return _navigate(changeCompanyLink(id));
  };

  const redirectoToAuth = () => {
    window.location.replace(authPath);
  };

  const isActive = (link: string, options?: { exact?: boolean }): boolean => {
    const fullPath = `${companyPath}${link}`;
    if (options?.exact) {
      return fullPath === pathname;
    }
    return pathname.startsWith(fullPath);
  };

  return {
    navigate,
    link,
    pathname,
    companyPath,
    changeCompany,
    changeCompanyLink,
    redirectoToAuth,
    authPath,
    rootPath,
    companyRootPath,
    isActive,
  };
};
